import {
  ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation, HostBinding,
  AfterViewInit, ChangeDetectorRef
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { AnimationCurves, AnimationDurations } from '../../../core/animation/animation';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'mcrai-panel-header',
  template: `<ng-content></ng-content>
<div
  *ngIf="collapsable"
  class="mcrai-panel__arrow"
  [@rotate]="collapsed"
></div>
`,
  styles: [`.mcrai-panel__header{display:flex;justify-content:flex-start;align-items:center;padding:0 20px;height:65px;margin-bottom:-1px}.mcrai-panel__header--collapsable{cursor:pointer;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:54px}.mcrai-panel__arrow{position:absolute;right:20px;top:0;bottom:0;margin:auto}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('rotate', [
      state('false', style({ transform: 'rotateX(180deg)' })),
      state('true', style({ transform: 'rotateX(0)' })),
      transition('0 => 1',
        animate(`${AnimationDurations.ENTERING} ${AnimationCurves.DECELERATION_CURVE}`)),
      transition('1 => 0',
        animate(`${AnimationDurations.LEAVING} ${AnimationCurves.ACCELERATION_CURVE}`))
    ])
  ]
})
export class HeaderComponent implements OnInit, AfterViewInit {
  readonly PANEL_HEADER_CLASS = 'mcrai-panel__header';

  clickEvent;

  @HostBinding('class.mcrai-panel__header--collapsable') collapsable = false;
  @HostBinding('class.mcrai-panel__header--collapsed') collapsed = false;

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef,
    private _changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.PANEL_HEADER_CLASS);
  }

  setCollapsable() {
    this.collapsable = true;
  }

  setCollapsed(collapsed: boolean) {
    this.collapsed = collapsed;
    this._changeDetectorRef.markForCheck();
  }

  ngAfterViewInit() {
    this.clickEvent = fromEvent(this._elRef.nativeElement, 'click');
  }

}
